import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import styles from './Activities.module.css';

// Import event images – each event now has multiple images
// Replace with your actual paths
import agmImg1 from '../../assets/images/cancer2.jpeg';
import agmImg2 from '../../assets/images/cancer1.jpeg';
import agmImg3 from '../../assets/images/cancer3.jpeg';
import agmImg4 from '../../assets/images/cancer4.jpeg';
import agmImg5 from '../../assets/images/cancer5.jpeg';
import agmImg6 from '../../assets/images/cancer6.jpeg';
import agmImg7 from '../../assets/images/cancer7.jpeg';
import agmImg8 from '../../assets/images/cancer8.jpeg';
import agmImg9 from '../../assets/images/cancer9.jpeg';
import agmImg10 from '../../assets/images/cancer10.jpeg';
import agmImg11 from '../../assets/images/cancer11.jpeg';
import agmImg12 from '../../assets/images/cancer12.jpeg';
import agmImg13 from '../../assets/images/cancer13.jpeg';
import agmImg14 from '../../assets/images/cancer14.jpeg';
import agmImg15 from '../../assets/images/cancer15.jpeg';
import agmImg16 from '../../assets/images/cancer16.jpeg';
import agmImg17 from '../../assets/images/cancer17.jpeg';
import agmImg18 from '../../assets/images/cancer18.jpeg';
import agmImg19 from '../../assets/images/cancer19.jpeg';

import excoImg1 from '../../assets/images/image3.jpg';
import excoImg2 from '../../assets/images/event1.jpg';

import cancerNewsImg1 from '../../assets/images/event1.jpg';
import cancerNewsImg2 from '../../assets/images/event1.jpg';

import cancerWeekImg1 from '../../assets/images/event1.jpg';
import cancerWeekImg2 from '../../assets/images/event1.jpg';
import cancerWeekImg3 from '../../assets/images/event1.jpg';
import worldhealthImg from '../../assets/images/worldhealth.jpg'

// Sample upcoming/past data (unchanged)
const upcomingActivities = [
  {
    id: 1,
    title: 'Annual Medical Outreach',
    date: 'May 15, 2026',
    location: 'Otukpo',
    description: 'Free health checks, medicines, and consultations for the community.',
  },
  {
    id: 2,
    title: 'Executive Committee Meeting',
    date: 'March 10, 2026',
    location: 'Virtual',
    description: 'Quarterly planning meeting for leadership.',
  },
  {
    id: 3,
    title: 'Journal Publication – Call for Papers',
    date: 'Deadline: April 30, 2026',
    description: 'Submit your research for the next issue of the Journal of Medical Research and Practice.',
  },
];

const pastActivities = [
  {
    id: 4,
    title: 'Health Awareness Webinar',
    date: 'January 20, 2025',
    description: 'Session on hypertension and diabetes prevention.',
  },
  {
    id: 5,
    title: 'IMDF Annual Gala',
    date: 'December 10, 2024',
    description: 'Fundraising and networking event.',
  },
  {
    id: 6,
    title: 'Medical Mission to Idoma Villages',
    date: 'October 5-7, 2024',
    description: 'Outreach to remote communities.',
  },
];

// Featured events – now with multiple images
const featuredEvents = [
  {
    id: 1,
    images: [agmImg1, agmImg3, agmImg4, agmImg5, agmImg6, agmImg7, agmImg8, agmImg9, agmImg10, agmImg11, agmImg12, agmImg13, agmImg14, agmImg15, agmImg16, agmImg17],
    title: 'Architect Sonny Echono Cancer Awareness Week.',
    link: '/activities/agm-2025',
  },
  {
    id: 2,
    images: [agmImg18],
    title: 'Health talk on cancer',
    link: '/activities/exco-retreat',
  },
  {
    id: 3,
    images: [excoImg1],
    title: 'Cancer Now Huge Threat in Benue State – IMDF Raises Alarm',
    date: 'Latest News',
    description: 'Newspaper headline: Cancer now huge threat in Benue state, IMDF raises alarm.',
    link: '/activities/cancer-news',
  },
  {
    id: 4,
    images: [agmImg19],
    title: 'Advocacy visit to the Otukpo LGA chairman ',
    description: 'Advocacy visit to the Otukpo LGA chairman at the start of the Arch Sonny Echono Cancer Awareness Week',
    link: '/activities/cancer-week',
  },
  {
    id: 5,
    images: [worldhealthImg],
    title: 'World Health Day 2027 ',
    description: '7 April is World Health Day',
    link: '/activities/cancer-week',
  },
  // {
  // id: 4,
  // images: [cancerWeekImg1, cancerWeekImg2, cancerWeekImg3],
  // title: 'Arch Sonny Echono Cancer Week',
  // date: 'Date TBA',
  // description: 'A week of awareness and screening events in honor of Arch Sonny Echono.',
  // link: '/activities/cancer-week',
  // },
];

const Activities = () => {
  const [activeImageIndices, setActiveImageIndices] = useState(
    featuredEvents.reduce((acc, event) => ({ ...acc, [event.id]: 0 }), {})
  );
  const [lightboxImage, setLightboxImage] = useState(null);

  const setActiveImage = (eventId, index) => {
    setActiveImageIndices(prev => ({ ...prev, [eventId]: index }));
  };

  const openLightbox = (imageSrc) => {
    setLightboxImage(imageSrc);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };

  return (
    <div className={styles.activities}>
      {/* Header – full width (unchanged) */}
      <section className={`${styles.header} ${styles.fullWidth}`}>
        <div className={styles.container}>
          <h1 className={styles.pageTitle}>Activities & Events</h1>
          <p className={styles.pageSubtitle}>
            Engaging our members and communities for a healthier Idoma nation
          </p>
        </div>
      </section>

      {/* ===== REVAMPED: Featured Events Grid with Galleries ===== */}
      <section className={styles.featuredEvents}>
        <SectionTitle title="Featured Events" subtitle="Don't miss out" align="center" />
        <div className={styles.featuredGrid}>
          {featuredEvents.map((event) => (
            <Card key={event.id} variant="elevated" className={styles.featuredCard}>
              {/* Main Image */}
              <div className={styles.featuredImageWrapper} onClick={() => openLightbox(event.images[activeImageIndices[event.id]])} style={{cursor: 'pointer'}}>
                <img
                  src={event.images[activeImageIndices[event.id]]}
                  alt={event.title}
                  className={styles.featuredImage}
                />
              </div>

              {/* Thumbnail Strip */}
              <div className={styles.thumbnailStrip}>
                {event.images.map((img, idx) => (
                  <button
                    key={idx}
                    className={`${styles.thumbnail} ${
                      idx === activeImageIndices[event.id] ? styles.activeThumbnail : ''
                    }`}
                    onClick={() => setActiveImage(event.id, idx)}
                    aria-label={`View image ${idx + 1}`}
                  >
                    <img src={img} alt={`Thumbnail ${idx + 1}`} />
                  </button>
                ))}
              </div>

              {/* Event Info */}
              <div className={styles.featuredContent}>
                <h3 className={styles.featuredTitle}>{event.title}</h3>
                <p className={styles.featuredDate}>{event.date}</p>
                <p className={styles.featuredDescription}>{event.description}</p>
                {/* <Link to={event.link} className={styles.featuredLink}>
              Learn More →
            </Link> */}
              </div>
            </Card>
          ))}
        </div>
      </section>
      {/* ===== End of Featured Events Grid ===== */}

      {/* Upcoming Activities – contained (unchanged) */}
      <section className={styles.upcoming}>
        <SectionTitle title="Upcoming Activities" subtitle="Get involved" align="center" />
        <div className={styles.cardGrid}>
          {upcomingActivities.map((activity) => (
            <Card key={activity.id} title={activity.title} variant="elevated" className={styles.activityCard}>
              <p className={styles.activityDate}>
                <strong>Date:</strong> {activity.date}
              </p>
              {activity.location && (
                <p className={styles.activityLocation}>
                  <strong>Location:</strong> {activity.location}
                </p>
              )}
              <p className={styles.activityDescription}>{activity.description}</p>
              {/* <Link to={`/activities/${activity.id}`} className={styles.readMore}>
              Learn more →
            </Link> */}
            </Card>
          ))}
        </div>
        <div className={styles.centered}>
          <Button variant="outline" size="medium">View All Upcoming</Button>
        </div>
      </section>

      {/* Past Activities – full width (unchanged) */}
      <section className={`${styles.past} ${styles.fullWidth}`}>
        <div className={styles.container}>
          <SectionTitle title="Past Activities" subtitle="Highlights" align="center" />
          <div className={styles.pastList}>
            {pastActivities.map((activity) => (
              <div key={activity.id} className={styles.pastItem}>
                <div className={styles.pastDate}>{activity.date}</div>
                <div className={styles.pastContent}>
                  <h3>{activity.title}</h3>
                  <p>{activity.description}</p>
                  {/* <Link to={`/activities/${activity.id}`} className={styles.readMore}>
                Read recap →
              </Link> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action – contained (unchanged) */}
      <section className={styles.cta}>
        <Card variant="elevated" className={styles.ctaCard}>
          <h3>Propose an Activity</h3>
          <p>
            Have an idea for an event, outreach, or publication? We'd love to hear from you.
          </p>
          <Link to="/contact">
            <Button variant="primary" size="large">Contact Us</Button>
          </Link>
        </Card>
      </section>

      {/* Lightbox Popup */}
      {lightboxImage && (
        <div className={styles.lightbox} onClick={closeLightbox}>
          <div className={styles.lightboxContent}>
            <img src={lightboxImage} alt="Full size" />
            <button className={styles.lightboxClose} onClick={closeLightbox}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Activities;